const SellLinesColumns = [
    { headerName: "Charge Type", field: "chargeType" },
    { headerName: "Brand", field: "brand" },
    { headerName: "Charge Period Date", field: "chargePeriodDate" },
    { headerName: "Vendor No.", field: "vendorNo" },
    { headerName: "Associate Vendor No.", field: "associateVendorNo" },
    { headerName: "Customer No.", field: "customerNo" },
    { headerName: "RA Number", field: "raNumber" },
    { headerName: "License Rental Agreement No.", field: "licenseRentalAgreementNo" },
    { headerName: "Charge Code1", field: "chargeCode1" },
    { headerName: "NetVoucher Value", field: "netVoucherValue" },
    { headerName: "DI Value", field: "diValue" },
    { headerName: "Total Sell Rentals", field: "totalSellRentals" },
    { headerName: "Charge Code2", field: "chargeCode2" },
    { headerName: "Voucher Fee", field: "voucherFee" },
    { headerName: "DI Fee", field: "diFee" },
    { headerName: "Total Fee", field: "totalFee" },
    { headerName: "Charge Code4", field: "chargeCode4" },
    { headerName: "Charge Code5", field: "chargeCode5" },
    { headerName: "Credit Club Value Purchase", field: "creditClubValuePurchase" },
    { headerName: "TM Split", field: "tmSplit" },
    { headerName: "CWD Split", field: "cwdSplit" },
    { headerName: "TP Split", field: "tpSplit" },
    { headerName: "PAI Split", field: "paiSplit" },
    { headerName: "LLI Split", field: "lliSplit" },
    { headerName: "One Way Fee", field: "oneWayFee" },
    { headerName: "Fuel", field: "fuel" },
    { headerName: "Cash Refund", field: "cashRefund" },
    { headerName: "Collection", field: "collection" },
    { headerName: "Tax", field: "tax" },
    { headerName: "Other Deductions", field: "otherDeductions" },
    { headerName: "Total Deductions", field: "totalDeductions" },
    { headerName: "Charge Code3", field: "chargeCode3" },
    { headerName: "Adjustment Value", field: "adjustmentValue" },
    { headerName: "Adjustment Reason Code", field: "adjustmentReasonCode" },
    { headerName: "Nav Reason Code", field: "navReasonCode" },
    { headerName: "Customer Billing Currency", field: "customerBillingCurrency" },
    { headerName: "Checkout Date", field: "checkoutDate" },
    { headerName: "Location Code", field: "locationCode" },
    { headerName: "Checkout Location", field: "checkoutLocation" },
    { headerName: "Checkin Location", field: "checkinLocation" },
    { headerName: "Customer Account No.", field: "customerAccountNo" },
    { headerName: "Customer Account Name", field: "customerAccountName" },
    { headerName: "IATA", field: "iata" },
    { headerName: "Agency Name", field: "agencyName" },
    { headerName: "Voucher Number", field: "voucherNumber" },
    { headerName: "Voucher Value", field: "voucherValue" },
    { headerName: "Voucher Commission", field: "voucherCommission" },
    { headerName: "Commission Tax", field: "commissionTax" },
    { headerName: "Sub Total", field: "subTotal" },
    { headerName: "Fee", field: "fee" },
    { headerName: "Net Buy/Sell", field: "netBuySell" },
    { headerName: "Country Code Bought From", field: "countryCodeBoughtFrom" },
    { headerName: "Commissionable Revenue", field: "commissionableRevenue" },
    { headerName: "Commission Percent", field: "commissionPercent" },
    { headerName: "Referral Commission", field: "referralCommission" },
    { headerName: "Referral Commission Tax", field: "referralCommissionTax" },
    { headerName: "Total Referral Commission & Tax", field: "totalReferralCommissionTax" },
    { headerName: "DI Value Sold/Purchased", field: "diValueSoldPurchased" },
    { headerName: "DI Buy/Sell Fee", field: "diBuySellFee" },
    { headerName: "Secondary CreditId", field: "secondaryCreditId" },
    { headerName: "Secondary Currency Code", field: "secondaryCurrencyCode" },
    { headerName: "FX Rate", field: "fxRate" },
    { headerName: "CL Indicator", field: "clIndicator" },
    { headerName: "Station Indicator", field: "stationIndicator" },
    { headerName: "Vehicle Registration No.", field: "vehicleRegistrationNo" }
  ];
  
  export default SellLinesColumns;